"use client"

import { Button } from "@/components/ui/button"

interface PricingToggleProps {
  billingPeriod: "monthly" | "annual"
  onToggle: (period: "monthly" | "annual") => void
}

export function PricingToggle({ billingPeriod, onToggle }: PricingToggleProps) {
  return (
    <div className="flex items-center bg-gray-100 rounded-lg p-1">
      <Button
        variant={billingPeriod === "monthly" ? "default" : "ghost"}
        size="sm"
        onClick={() => onToggle("monthly")}
        className={billingPeriod === "monthly" ? "bg-white text-gray-900 shadow-sm" : "text-gray-600"}
      >
        Monthly
      </Button>
      <Button
        variant={billingPeriod === "annual" ? "default" : "ghost"}
        size="sm"
        onClick={() => onToggle("annual")}
        className={billingPeriod === "annual" ? "bg-white text-gray-900 shadow-sm" : "text-gray-600"}
      >
        Annual
        <span className="ml-2 text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full">Save 20%</span>
      </Button>
    </div>
  )
}
